import(/* webpackMode: "eager" */ "/vercel/path0/src/app/en/blog/botox-prices-2026/page.tsx");
